import Konva from "konva";
import { createSeat, emptySeat, getSeatLabelAttrs } from "../seatUtils";
import { SEAT } from "../Constants";
import { usedIds } from "@/core/UsedIds";
import { ticketsCount } from "@/core/TicketsCount";


const seatSize = SEAT.size; // Size of each seat (square)
const seatMargin = 10; // Margin between each seat

export const roundTableBind = (seatsBind, id, saved, component, configs) => {
  let seatsCount = 0;
  const seatsLength = seatsBind.length;
  let tableRadius = Math.max(seatsLength * 8, 30); // Calculate the tableRadius dynamically
  const numberDirection = !configs.direction || (configs.direction && configs.direction === 'clockwise');
  let seatDistance = tableRadius + seatSize + 10;
  let roundTableGroup = new Konva.Group();
  roundTableGroup.type = "round";
  let table = new Konva.Circle({
    radius: tableRadius,
    stroke: "white",
    strokeWidth: 1,
  });
  roundTableGroup.add(table);

  let mainSeatGroup = new Konva.Group();
  mainSeatGroup.type = "seatGroup";



  const putTableSeats = (i,index) => {
    let angle = (i / seatsLength) * Math.PI * 2;

    let seatX = Math.cos(angle) * seatDistance;
    let seatY = Math.sin(angle) * seatDistance;

    let seatRotation = angle + Math.PI / 2; // calculate rotation angle

    let offsetX = Math.cos(seatRotation) * (seatSize / 2);
    let offsetY = Math.sin(seatRotation) * (seatSize / 2);

    let seatGroup = new Konva.Group({
      x: seatX - offsetX,
      y: seatY - offsetY,
      rotation: seatRotation * (180 / Math.PI),
      groupId: id, // convert rotation to degrees
    });


    const seatText = seatsBind[index].number;
    const invalid = seatsBind[index].invalid ?? false;
    const broken = seatsBind[index].broken ?? false;

    const rotation = -(seatRotation * (180 / Math.PI));

    const {seat, seatNumber} = createSeat(0, 0, seatText, invalid, seatGroup, rotation, broken);

    seatGroup.setAttrs({
      deleted: !(seatText || seatText === 0)
    })

    seatGroup.setAttrs({ number: seatText, id: seatsBind[i].id, invalid, broken });
    seatGroup.number = seatText;
    seatGroup.invalid = invalid;
    seatGroup.broken = broken;
    seatGroup.id = seatsBind[i].id;

    if(saved) {
      usedIds.add(seatsBind[i].id)
    }

    if (!seatText && seatText !== 0) {
      emptySeat(seat, seatNumber, seatGroup);
    } else if (!broken) {
      seatsCount++
    }

    mainSeatGroup.add(seatGroup);
  }

  if(numberDirection) {
    for (let i = 0; i < seatsBind.length; i++) {
      putTableSeats(i, i)
    }
  } else {
    for (let i = seatsBind.length - 1; i >= 0; i--) {
      putTableSeats(seatsBind.length - 1- i, i)
    }
  }

  roundTableGroup.add(mainSeatGroup);
  component.countTickets(id, seatsCount, 'seats');
  return { roundTableGroup, mainSeatGroup };
};

export const rectangleTableBind = (seatsBind, id, saved, component, configs) => {
  
  const rectangleTableGroup = new Konva.Group();
  rectangleTableGroup.type = "rectangle";
  let seatsCount = 0;
  let seatsLength = seatsBind.length; // Number of seats
  let rectHeight = configs.width;
  const numberDirection = !configs.direction || (configs.direction && configs.direction === 'clockwise');
  const xSeatsLength = configs.sides[0] / 2;
  const ySeatsLength = configs.sides[1] / 2;
  let rectWidth = xSeatsLength * (seatSize + seatMargin) - seatMargin;
  let rect = new Konva.Rect({
    width: rectWidth,
    height: rectHeight,
    stroke: "white",
    strokeWidth: 1,
    offsetX: rectWidth / 2,
    offsetY: rectHeight / 2
  });

  rect.type = "rectTable";
  rectangleTableGroup.add(rect);

  // Calculate the number of seats that can fit on each side
  let seatGroup = new Konva.Group();
  seatGroup.type = "seatGroup";

  // let topGroup = new Konva.Group();
  // Arrange seats on the top side
  let seatTop, seatLeft;
  const putTableSeats = (i, index) => {
    let seatWithNum = new Konva.Group();
    const invalid = seatsBind[index].invalid ?? false;
    const broken = seatsBind[index].broken ?? false;
    const seatText = seatsBind[index].number;

    if(i < xSeatsLength) {
        seatTop = -(seatSize + seatMargin) - rectHeight / 2;
        seatLeft = i * (seatSize + seatMargin) - rectWidth / 2
    } else if (i >= xSeatsLength && i < xSeatsLength + ySeatsLength) {
        seatTop = (i - xSeatsLength) * (seatSize + seatMargin) - rectHeight / 2;
        seatLeft = rectWidth / 2 + seatMargin
    } else if (i >= xSeatsLength + ySeatsLength && i < xSeatsLength * 2 + ySeatsLength) {
        seatTop = rectHeight / 2 + seatMargin;
        const bottomIndex = ySeatsLength === 0 && !configs.reverse ? i - xSeatsLength : seatsLength - i - ySeatsLength - 1;
        // const bottomIndex =  seatsLength - i - ySeatsLength - 1;
        seatLeft = bottomIndex * (seatSize + seatMargin) - rectWidth / 2
    } else {
        seatTop = (seatsLength - i - 1) * (seatSize + seatMargin) - rectHeight / 2;
        seatLeft = -rectWidth / 2 - (seatSize + seatMargin) 
    }

    const {seat, seatNumber} = createSeat(seatLeft, seatTop, seatText, invalid, seatWithNum, undefined, broken);

    seatWithNum.setAttrs({ deleted: !(seatText || seatText === 0) });
    seatWithNum.setAttrs({ number: seatText, id: seatsBind[i].id, invalid, broken });

    seatWithNum.number = seatText;
    seatWithNum.invalid = invalid;
    seatWithNum.broken = broken;
    seatWithNum.id = seatsBind[i].id;
    seatWithNum.setAttrs({
      groupId: id
    })

    if(saved) {
      usedIds.add(seatsBind[i].id)
    }

    if (!seatText && seatText !== 0) {
      emptySeat(seat, seatNumber, seatWithNum);
    } else if (!broken) {
      seatsCount++
    }

    seatGroup.add(seatWithNum);
  }

  if(numberDirection) {
    for (let j = 0; j < seatsLength; j++) {
      putTableSeats(j, j)
    }
  } else {
    for (let j = seatsLength - 1; j >= 0; j--) {
      putTableSeats(seatsLength - j - 1, j)
    }
  }
  

  rectangleTableGroup.add(seatGroup);
  component.countTickets(id, seatsCount, 'seats');
  return { rectangleTableGroup, seatGroup, rect };
};

export const squareTableBind = (seatsBind, id, saved, component, configs) => {
  const squareTableGroup = new Konva.Group();
  const square = new Konva.Rect({
    stroke: "white",
    strokeWidth: 1,
  });
  let seatsCount = {'count': 0};
  squareTableGroup.add(square);
  let seatsGroup = new Konva.Group();
  seatsGroup.type = "seatGroup";
  const numberDirection = !configs.direction || (configs.direction && configs.direction === 'clockwise');
  const seatsLength = seatsBind.length;
  const sideSeats = Math.floor(seatsLength / 4);
  const rectHeight = sideSeats * (seatSize + seatMargin) - seatMargin;
  const rectWidth = rectHeight;
  square.setAttrs({
    width: rectHeight,
    height: rectHeight,
    offsetX: rectHeight / 2,
    offsetY: rectHeight / 2
  });

  // for (let i = 0; i < 4; i++) {
  //   let slicedArray = seatsBind.slice(i * calc, i * calc + calc);

  //   let horY;
  //   let verX;
  //   if (i === 0) horY = square.y() - seatSize - seatMargin - borderSize / 2;
  //   if (i === 2) {
  //     horY = square.y() + square.height() + seatMargin - borderSize / 2;
  //     slicedArray = slicedArray.reverse();
  //   }

  //   if (i === 1) verX = square.x() + square.width() + seatMargin - borderSize / 2;
  //   if (i === 3) {
  //     verX = square.x() - seatMargin - seatSize - borderSize / 2;
  //     slicedArray = slicedArray.reverse();
  //   }

  //   if (i === 0 || i === 2) {
  //     drawSeats(square.x(), horY, slicedArray, "horizontal", i, saved, id, seatsCount);
  //   } else if (i === 1 || i === 3) {
  //     drawSeats(verX, square.y(), slicedArray, "vertical", i, saved, id, seatsCount);
  //   }
  // }

  // function drawSeats(x, y, seatsBind, type, side, saved, id, seatsCount) {
  //   const seatsPerSide = seatsBind.length;
  //   const putTableSeats = (i, index) => {
  //     const seatText = seatsBind[index].number;
  //     const invalid = seatsBind[index].invalid;

  //     const saveIndex = side !== 0 ? side * seatsPerSide + i + 1 : i + 1;

  //     const seatWithNum = new Konva.Group();

  //     let x_;
  //     let y_;

  //     if (type === "horizontal") {
  //       x_ = 5 + x + i * (seatSize + seatMargin) - borderSize / 2;
  //       y_ = y;
  //     } else {
  //       x_ = x;
  //       y_ = 5 + y + i * (seatSize + seatMargin) - borderSize / 2;
  //     }
      
  //     seatWithNum.setAttrs({ deleted: !(seatText || seatText === 0) })
  //     const {seat, seatNumber} = createSeat(x_, y_, seatText, invalid, seatWithNum);

  //     seatWithNum.id = seatsBind[i].id;
  //     seatWithNum.invalid = invalid;
  //     seatWithNum.setAttrs({
  //       number: seatText,
  //       id: seatsBind[i].id,
  //       invalid,
  //       saveIndex,
  //       groupId: id,
  //     });

  //     if(saved) {
  //       usedIds.add(seatsBind[i].id)
  //     }

  //     seatWithNum.number = seatText;

  //     if (!seatText && seatText !== 0) {
  //       emptySeat(seat, seatNumber, seatWithNum);
  //     } else {
  //       seatsCount['count'] = seatsCount['count'] + 1;
  //     }
     
  //     seatsGroup.add(seatWithNum);
  //   }

  //   if(numberDirection) {
  //     for (let i = 0; i < seatsBind.length; i++) {
  //       putTableSeats(i, i)
  //     }
  //   } else {
  //     for (let i = seatsBind.length - 1; i >= 0; i--) {
  //       putTableSeats(seatsBind.length - 1- i, i)
  //     }
  //   }
    
    
    
  // }

  let seatTop, seatLeft;
  const putTableSeats = (i, index) => {
    let seatWithNum = new Konva.Group();
    const invalid = seatsBind[index].invalid ?? false;
    const broken = seatsBind[index].broken ?? false;
    const seatText = seatsBind[index].number;

    if(i < sideSeats) {
        seatTop = -(seatSize + seatMargin) - rectHeight / 2;
        seatLeft = i * (seatSize + seatMargin) - rectWidth / 2
    } else if (i >= sideSeats && i < sideSeats * 2) {
        seatTop = (i - sideSeats) * (seatSize + seatMargin) - rectHeight / 2;
        seatLeft = rectWidth / 2 + seatMargin
    } else if (i >= sideSeats * 2 && i < sideSeats * 3) {
        seatTop = rectHeight / 2 + seatMargin;
        seatLeft = (seatsLength - i - sideSeats - 1) * (seatSize + seatMargin) - rectWidth / 2
    } else {
        seatTop = (seatsLength - i - 1) * (seatSize + seatMargin) - rectHeight / 2;
        seatLeft = -rectWidth / 2 - (seatSize + seatMargin) 
    }

    const {seat, seatNumber} = createSeat(seatLeft, seatTop, seatText, invalid, seatWithNum, undefined, broken);

    seatWithNum.setAttrs({ deleted: !(seatText || seatText === 0) });
    seatWithNum.setAttrs({ number: seatText, id: seatsBind[i].id, invalid, broken });

    seatWithNum.number = seatText;
    seatWithNum.invalid = invalid;
    seatWithNum.broken = broken;
    seatWithNum.id = seatsBind[i].id;
    seatWithNum.setAttrs({
      groupId: id
    })

    if(saved) {
      usedIds.add(seatsBind[i].id)
    }

    if (!seatText && seatText !== 0) {
      emptySeat(seat, seatNumber, seatWithNum);
    } else if (!broken) {
      seatsCount['count'] = seatsCount['count'] + 1;
    }

    seatsGroup.add(seatWithNum);
  }

  if(numberDirection) {
    for (let j = 0; j < seatsLength; j++) {
      putTableSeats(j, j)
    }
  } else {
    for (let j = seatsLength - 1; j >= 0; j--) {
      putTableSeats(seatsLength - j - 1, j)
    }
  }

  component.countTickets(id, seatsCount['count'], 'seats');
  return { squareTableGroup, seatsGroup, square };
};

export const recoverTableSeatNumber = (seat, seatsBind) => {
  fillSeatFunction(seat, seatsBind);
  
};


const fillSeatFunction = (seat, seatsBind) => {
  const { index } = seat;
  seat.number = index + 1;
  let numberNode;
  const seatId = seat.id;

  seat.find((node) => {
    if (node instanceof Konva.Rect) {
      node.setAttrs({
        stroke: "white",
      });

    } else {
      node.setAttrs({
        ...getSeatLabelAttrs(seat.number, seat.invalid, seat.broken),
        number: seat.number,
      });
      node.visible(true);
      numberNode = node;
    }
  });

  let seatItem = seatsBind.find((s) => s.id === seatId);
  seatItem.number = seat.number;
  seatItem.broken = false;
  seatItem.invalid = false;
  seat.broken = false;
  seat.invalid = false;
  seat.setAttrs({ broken: false, invalid: false, text: seat.number, number: seat.number });

};

export const mergeArrays = (oldData, newData) => {
  const mergedArray = [];
  for (let i = 0; i < newData.length; i++) {
    const seat = newData[i];
    if (oldData[i]) {
      seat.number = oldData[i].number;
      seat.id = oldData[i].id;
      seat.invalid = oldData[i].invalid ?? false;
      seat.broken = oldData[i].broken ?? false;
    }
    mergedArray.push(seat);
  }

  return mergedArray;
};

export const mergeSecArrays = (arr1, arr2) => {
  const mergedArray = [];
  const arr2Length = arr2.length;

  for (let i = 0; i < arr2Length; i++) {
    const arr2Seat = arr2[i];

    const seats = arr2[i].seats;
    const seatLength = arr2[i].seats.length;

    if (arr1[i]) arr2Seat.id = arr1[i].id;

    for (let j = 0; j < seatLength; j++) {
      const seat = seats[j];
      if (arr1[i]) {
        if (arr1[i].seats[j]) {
          seat.id = arr1[i].seats[j].id;
          seat.invalid = arr1[i].seats[j].invalid;
          if (!arr1[i].seats[j].number) {
            seat.number = null;
          }
        }
      }
    }

    mergedArray.push(arr2Seat);
  }

  return mergedArray;
};
